// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"811":"daf83c89","3360":"10d4075b"}[chunkId] + ".chunk.css";
};